"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFallback = exports.initialize = void 0;
var gatewayCaller_1 = __importDefault(require("@atg/icf-platform/lib/client/gatewayCaller"));
var StatsDClient_1 = require("icf-search-client-shared/lib/services/StatsDClient");
var promisedState = null;
var gatewayCaller = (0, gatewayCaller_1.default)("da48cfde-b78e-4dca-bd12-d6660fcccf2d");
var domain = null;
var lastCallTime;
var initialize = function (args) {
    if (domain) {
        return;
    }
    console.log("Initializing performer fallback module");
    domain = args.domain;
    promisedState = gatewayCaller.get({ url: "/v4/performers/fallback", params: { domain: domain } });
    lastCallTime = Date.now();
    StatsDClient_1.statsd.count("recommenders.fallback.initialize");
};
exports.initialize = initialize;
var getFallback = function () {
    var retVal = promisedState;
    // this function will gets called every time we get the performers list
    // nginx cache is set to 9-11 minutes max age
    // every 8 minutes this function will make a request
    // otherwise will do nothing
    if (Date.now() - lastCallTime >= 8 * 60 * 1000) {
        promisedState = gatewayCaller.get({ url: "/v4/performers/fallback", params: { domain: domain } });
        lastCallTime = Date.now();
        StatsDClient_1.statsd.count("recommenders.fallback.refresh");
    }
    return retVal;
};
exports.getFallback = getFallback;
//# sourceMappingURL=PerformerFallback.js.map